module.exports = __webpack_public_path__ + "organigramme/img/microscope_x5.cfcd30e7.svg";